var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg403Desk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "856px",
    height: "281px",
    viewBox: "0 0 856 281",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "69.8887972%",
    y1: "122.196689%",
    x2: "50%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E4E4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBCBC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "9.15593807%",
    y1: "50%",
    x2: "93.4026202%",
    y2: "37.7801853%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBCBC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "69.8887972%",
    y1: "122.196689%",
    x2: "50%",
    y2: "0%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBCBC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "25.365515%",
    y1: "3.94981298%",
    x2: "82.0367661%",
    y2: "105.618498%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBCBC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "60.426712%",
    y1: "18.7737542%",
    x2: "50%",
    y2: "95.0406461%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBCBC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "15.884048%",
    y1: "64.0348136%",
    x2: "100%",
    y2: "64.0348136%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D5D5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F2F2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-6.1%",
    y: "-7.2%",
    width: "112.3%",
    height: "128.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-7"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 16,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.48 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "84.6983863%",
    y1: "0%",
    x2: "23.2742059%",
    y2: "100%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBCBC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "15.884048%",
    y1: "64.0348136%",
    x2: "100%",
    y2: "64.0348136%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tilting-Point-404",
    transform: "translate(-353.000000, -388.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(366.000000, 388.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "You-can\\u2019t-view-this",
    fontFamily: "Raleway-Bold, Raleway",
    fontSize: 22,
    fontWeight: "bold",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 577,
    y: 125
  }, "You can\u2019t view this page. "), /*#__PURE__*/React.createElement("tspan", {
    x: 577,
    y: 151
  }, "Contact admin to change "), /*#__PURE__*/React.createElement("tspan", {
    x: 577,
    y: 177
  }, "your level of access.")), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(0.000000, 11.000000)",
    opacity: 0.96
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(89.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.15014493,0.760803213 C1.15014493,0.760803213 1.34396365,10.784439 1.15014493,15.9768675 C0.956326203,21.169296 0,31.5733333 0,31.5733333 C0,31.5733333 2.86242242,31.2918839 5.75072464,30.4321285 C8.63902685,29.5723731 11.5014493,28.1497189 11.5014493,28.1497189 L12.2682126,0.380401606 C12.2682126,0.380401606 9.20068982,0.668998203 6.51748792,0.760803213 C3.83428603,0.852608223 1.15014493,0.760803213 1.15014493,0.760803213 Z",
    id: "Path-5",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.766763285,31.1929317 C0.766763285,31.1929317 1.97070761,29.4656698 3.06705314,27.3889157 C4.16339867,25.3121615 4.98396135,23.204498 4.98396135,23.204498 C4.98396135,23.204498 8.97998772,23.121414 14.9518841,22.0632932 C20.9237804,21.0051723 26.4533333,19.4004819 26.4533333,19.4004819 C26.4533333,19.4004819 24.6477714,23.2627178 23.3862802,25.2967068 C22.124789,27.3306959 20.3192271,29.2909237 20.3192271,29.2909237 C20.3192271,29.2909237 16.1527252,30.322773 11.1180676,30.8125301 C6.08341008,31.3022873 0.766763285,31.1929317 0.766763285,31.1929317 Z",
    id: "Path-7",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.6836715,9.12963855 L5.367343,1.14120482 C5.367343,1.14120482 8.20779006,0.59481226 13.6100483,0.380401606 C19.0123066,0.165990953 24.5364251,0.380401606 24.5364251,0.380401606 L21.0859903,7.98843373 C21.0859903,7.98843373 15.2819014,7.72406785 11.8848309,7.98843373 C8.48776039,8.25279962 2.6836715,9.12963855 2.6836715,9.12963855 Z",
    id: "Path-6",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0349758,12.1728514 C13.0349758,12.1728514 12.4257514,14.0373662 11.5014493,15.5964659 C10.5771472,17.1555656 9.20115942,18.6396787 9.20115942,18.6396787 C9.20115942,18.6396787 11.8726533,18.7352106 14.5685024,18.6396787 C17.2643515,18.5441468 19.9358454,18.2592771 19.9358454,18.2592771 C19.9358454,18.2592771 21.3704439,16.102625 21.8527536,15.0258635 C22.3350633,13.9491019 23.0028986,11.4120482 23.0028986,11.4120482 C23.0028986,11.4120482 19.8921204,12.0006187 17.6355556,12.1728514 C15.3789907,12.3450841 13.0349758,12.1728514 13.0349758,12.1728514 Z",
    id: "Path-8",
    fill: "url(#linearGradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(54.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8325335,22.9280878 C28.5606537,29.2 21.9182871,31.7711862 15.6882464,31.7711862 C7.02386716,31.7711862 0,24.7868283 0,16.1711862 C0,7.55554412 7.02386716,0.571186214 15.6882464,0.571186214 C17.1768326,0.571186214 21.5645354,0.186017233 22.9289755,0.571186214 C18.1010489,2.14017223 11.6656191,7.24631355 11.6656191,12.5711862 C11.6656191,19.1986032 17.0685938,24.5711862 23.7335009,24.5711862 C25.9585098,24.5711862 28.0428779,23.9724184 29.8325335,22.9280878 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64299183,8.50020318 L13.27467,0.4 C13.27467,0.4 16.4927718,0 22.12445,0 C27.7561282,0 33.3878064,1.30020318 33.3878064,1.30020318 L27.7561282,8.50020318 C27.7561282,8.50020318 21.7221873,7.6 17.69956,7.6 C13.6769327,7.6 7.64299183,8.50020318 7.64299183,8.50020318 Z",
    id: "Path-6",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.599134,25.8888889 L20.0013967,15.4888889 C20.0013967,15.4888889 22.0127104,15.0888889 27.6443886,15.4888889 C33.2760668,15.8888889 34.4828549,16.6888889 34.4828549,16.6888889 C34.4828549,16.6888889 35.9722258,19.4159817 36.4941686,20.8 C37.0161114,22.1840183 38.1032195,26.2888889 38.1032195,26.2888889 C38.1032195,26.2888889 32.873804,24.6888889 28.8511768,24.6888889 C24.8285495,24.6888889 19.599134,25.8888889 19.599134,25.8888889 Z",
    id: "Path-6",
    fill: "url(#linearGradient-3)",
    transform: "translate(28.851177, 20.800000) rotate(-270.000000) translate(-28.851177, -20.800000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6656191,20.1002032 L17.2972973,12 C17.2972973,12 20.5153991,11.6 26.1470773,11.6 L34.5945946,11.6 L28.9629164,19.6 C28.9629164,19.6 25.7448146,19.2 21.7221873,19.2 C17.69956,19.2 11.6656191,20.1002032 11.6656191,20.1002032 Z",
    id: "Path-6",
    fill: "url(#linearGradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.432432432 C0,0.432432432 1.51591367,12.2595202 1.2972973,18.1621622 C1.07868093,24.0648041 0.432432432,32 0.432432432,32 L6.91891892,32 C9.94594595,32 12.5405405,30.2702703 12.5405405,30.2702703 L12.5405405,0 C12.5405405,0 9.08058771,0.328069203 6.05405405,0.432432432 C3.0275204,0.536795662 0,0.432432432 0,0.432432432 Z",
    id: "Path-5",
    fill: "url(#linearGradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.45945946,6.98298298 L9.51351351,0.0640640641 C9.51351351,0.0640640641 28.972973,-0.432432432 29.8378378,7.84784785 C30.7027027,16.1281281 25.0810811,17.2972973 21.6216216,18.5945946 C18.1621622,19.8918919 3.02702703,19.8918919 3.02702703,19.8918919 L9.94594595,12.5405405 C9.94594595,12.5405405 17.2972973,13.037037 18.1621622,10.8748749 C22.4864865,5.25325325 3.45945946,6.98298298 3.45945946,6.98298298 Z",
    id: "Path-9",
    fill: "url(#linearGradient-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(20.000000, 0.000000)",
    fill: "url(#linearGradient-3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8165672,5.10979987 L18.553676,5.10979987 L24.0803029,4.32367681 L9.86897659,31.4449223 L4.73710876,31.8379838 L0,31.4449223 C0,31.4449223 5.51469709,22.4216308 7.89518127,17.8842995 C10.2756655,13.3469683 13.8165672,5.10979987 13.8165672,5.10979987 Z",
    id: "Path-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.07945846,25.5489993 C10.5323674,24.309004 12.7584173,23.2514409 14.2113263,22.0114456 C15.5217308,20.8930717 17.3693988,18.4738918 17.3693988,18.4738918 L22.8960257,18.0808303 L30.3964479,16.5085842 L27.6331344,21.0287918 L24.869821,23.9767532 C24.869821,23.9767532 19.3179593,24.8833074 16.5798807,25.1559378 C13.841802,25.4285683 11.604834,25.2975477 9.07945846,25.5489993 Z",
    id: "Path-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3956035,2.35836917 C15.3956035,2.35836917 18.1602463,12.3847472 20.1327122,17.2947072 C22.1051782,22.2046673 26.4488573,29.8726762 26.4488573,29.8726762 C26.4488573,29.8726762 31.0924647,30.0785168 33.1597613,29.8726762 C35.227058,29.6668355 38.2916292,28.6934916 38.2916292,28.6934916 C38.2916292,28.6934916 32.3303524,19.7835088 30.3964479,14.9363381 C28.4625434,10.0891674 26.8436163,0 26.8436163,0 C26.8436163,0 23.4986691,0.811066686 21.7117485,1.17918459 C19.9248279,1.54730248 15.3956035,2.35836917 15.3956035,2.35836917 Z",
    id: "Path-3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    filter: "url(#filter-7)",
    opacity: 0.96
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    fill: "url(#linearGradient-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(88.000000, 89.262948) rotate(-270.000000) translate(-88.000000, -89.262948) translate(-0.500000, 1.549801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,18.1338297 C10.6471981,19.3583996 19.8917985,18.1338297 37.5733971,15.8671009 C55.2549957,13.6003722 70.5324752,9.06691483 70.5324752,9.06691483 C86.3260539,30.3940445 95.0385927,49.8680315 114.930391,77.068776 C133.664616,102.686613 174.605787,149.604095 174.605787,149.604095 L125.98139,167.737924 C125.98139,167.737924 92.6980404,138.967197 61.8855952,102.002792 C32.2912997,66.4997494 5.23084525,22.8450163 0,18.1338297 Z",
    id: "Path-4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    points: "119.350791 0 125.98139 174.53811 174.605787 149.604095 176.815986 0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(118.000000, 32.042297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.38858371 C0,2.38858371 8.12136278,67.7166837 6.95014645,100.320516 C5.77893012,132.924348 2.31671548,176.755195 2.31671548,176.755195 L37.0674477,176.755195 C53.2844561,176.755195 67.184749,167.20086 67.184749,167.20086 L67.184749,0 C67.184749,0 48.648382,1.81212299 32.4340168,2.38858371 C16.2196516,2.96504443 0,2.38858371 0,2.38858371 Z",
    id: "Path-5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(174.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.19533,131.317525 C142.834538,165.845266 109.615433,180 78.4584082,180 C35.1270259,180 0,141.550147 0,94.1198505 C0,46.6895536 35.1270259,8.23970099 78.4584082,8.23970099 C85.9029692,8.23970099 107.846287,6.11929268 114.669981,8.23970099 C90.5250624,16.8771852 58.3408676,44.9871967 58.3408676,74.3013545 C58.3408676,110.786198 85.3616567,140.363008 118.693489,140.363008 C129.82097,140.363008 140.245092,137.066709 149.19533,131.317525 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8888889,48.6824751 C35.2496805,14.1547344 68.4687857,0 99.6258103,0 C142.957193,0 178.084218,38.4498526 178.084218,85.8801495 C178.084218,133.310446 142.957193,171.760299 99.6258103,171.760299 C92.1812493,171.760299 70.2379314,173.880707 63.4142373,171.760299 C87.5591561,163.122815 119.743351,135.012803 119.743351,105.698646 C119.743351,69.2138018 92.7225617,39.6369921 59.3907292,39.6369921 C48.2632488,39.6369921 37.8391265,42.9332912 28.8888889,48.6824751 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(367.000000, 2.000000)",
    fill: "url(#linearGradient-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.7192481,13.7586535 C86.7192481,13.7586535 104.056422,78.7414056 102.885206,115.403304 C101.713989,152.065203 82.3507222,210.755195 82.3507222,210.755195 C82.3507222,210.755195 106.167347,210.755195 122.384355,210.755195 C123.323755,210.755195 142.184749,200.011671 142.184749,200.011671 C142.184749,200.011671 152.965497,154.391863 152.965497,106.952765 C152.965497,59.5136669 142.656302,11.0727725 142.656302,11.0727725 C142.656302,11.0727725 128.753366,13.110443 112.539001,13.7586535 C96.3246359,14.4068639 86.7192481,13.7586535 86.7192481,13.7586535 Z",
    id: "Path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0481305,106.82448 C60.0481305,106.82448 62.0679871,151.766867 60.6186301,175.749483 C59.1692731,199.732098 43.5081388,255.207034 43.5081388,255.207034 C43.5081388,255.207034 53.9193075,252.962739 66.1782778,251.366352 C78.4372481,249.769964 87.2793647,250.388265 87.2793647,250.388265 C87.2793647,250.388265 105.116024,207.985768 107.250166,177.466113 C109.384308,146.946459 110.085169,136.923683 110.085169,136.923683 L100.453929,117.061162 C100.453929,117.061162 86.6792518,112.73886 82.0995239,111.832272 C62.8542936,108.022547 60.0481305,106.82448 60.0481305,106.82448 Z",
    id: "Path-5",
    transform: "translate(76.796654, 181.015757) scale(-1, -1) rotate(-94.000000) translate(-76.796654, -181.015757) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7434475,-31.2777333 C63.7434475,-31.2777333 65.763304,13.6646532 64.313947,37.6472687 C62.86459,61.6298843 41.8057656,115.907867 41.8057656,115.907867 C41.8057656,115.907867 54.8791896,116.162948 72.142575,115.071701 C73.3046347,114.998245 98.7401948,112.04921 98.7401948,112.04921 C98.7401948,112.04921 107.169222,66.6167742 107.169222,35.5841846 C107.169222,4.5515949 114.639127,-19.2085159 114.639127,-19.2085159 C114.639127,-19.2085159 111.184232,-21.8331363 91.9390015,-25.6428615 C72.6937712,-29.4525868 63.7434475,-31.2777333 63.7434475,-31.2777333 Z",
    id: "Path-5",
    transform: "translate(78.222446, 42.328011) scale(-1, 1) rotate(-94.000000) translate(-78.222446, -42.328011) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(72.500000, 110.000000) rotate(-270.000000) translate(-72.500000, -110.000000) translate(56.500000, 78.500000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    points: "0.516363228 0 4.08783478 63 31.4691166 43.9899256 31.4691166 0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(621.000000, 212.000000)",
    fill: "#D0021B"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 34.5,
    cy: 34.5,
    r: 34.5
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg403Desk);
export default __webpack_public_path__ + "static/media/403-desk.26f8f74a.svg";
export { ForwardRef as ReactComponent };